<template>
    <div :class="['h-screen flex overflow-hidden', backgroundClass]">
        <component
            v-if="sidebarReady"
            :is="sidebarComponent"
            :sidebarVisible="sidebarVisible"
            :collapsed="menuCollapsed"
            @toggle-sidebar="toggleSidebar"
            @toggle-menu-collapsed="toggleMenuCollapsed"
        ></component>
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
            <navbar :home-to="homeTo" @toggle-sidebar="toggleSidebar"></navbar>
            <router-view></router-view>
        </div>
        <navigation-shortcut-leader-indicator></navigation-shortcut-leader-indicator>
    </div>
</template>

<script>
import Navbar from "@/components/layout/workspace/navbar";
import NavigationShortcutLeaderIndicator from "@/components/navigation-shortcuts/leader-indicator";
import {registerNavigationShortcuts} from "@/utils/navigation-shortcuts";
import {getAuthToken} from "@/utils/auth-token";

export default {
    name: "app-layout-shell",
    components: {NavigationShortcutLeaderIndicator, Navbar},
    props: {
        sidebarComponent: {
            type: [Object, String],
            required: true,
        },
        homeTo: {
            type: String,
            required: true,
        },
        backgroundClass: {
            type: String,
            required: false,
            default: 'bg-stage-background',
        },
    },
    data() {
        return {
            sidebarVisible: false,
            menuCollapsed: false,
            unregisterNavigationShortcuts: null,
            sidebarReady: false,
        };
    },
    mounted() {
        this.loadMenuCollapsed();
        this.bootstrapSidebar();
        this.unregisterNavigationShortcuts = registerNavigationShortcuts({
            router: this.$router,
            store: this.$store,
        });
    },
    beforeUnmount() {
        if (typeof this.unregisterNavigationShortcuts === 'function') {
            this.unregisterNavigationShortcuts();
            this.unregisterNavigationShortcuts = null;
        }
    },
    methods: {
        bootstrapSidebar() {
            const token = getAuthToken();
            if (!token) {
                this.sidebarReady = true;
                return;
            }

            if (this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.role) {
                this.sidebarReady = true;
                return;
            }

            axios.get('api/auth/user').then((response) => {
                const data = response && response.data ? response.data : null;
                if (data && data.role) {
                    this.$store.commit('updateUser', data);
                }
            }).finally(() => {
                this.sidebarReady = true;
            });
        },
        loadMenuCollapsed() {
            try {
                this.menuCollapsed = localStorage.getItem('stage_menu_collapsed') === '1';
            } catch (e) {
                this.menuCollapsed = false;
            }
        },
        toggleMenuCollapsed(force = null) {
            if (force !== null) {
                this.menuCollapsed = force;
            } else {
                this.menuCollapsed = !this.menuCollapsed;
            }

            try {
                localStorage.setItem('stage_menu_collapsed', this.menuCollapsed ? '1' : '0');
            } catch (e) {
                // Ignore storage errors in private mode.
            }
        },
        toggleSidebar(force = null) {
            if (force !== null) {
                this.sidebarVisible = force;
            } else {
                this.sidebarVisible = !this.sidebarVisible;
            }
        },
    },
}
</script>
